import React, { Component, PropTypes } from 'react'

export default class PhotoForm extends Component {
    static propTypes = {
        actions: PropTypes.object.isRequired,
        data: PropTypes.object,
        errors: PropTypes.object.isRequired,
        photo: PropTypes.object.isRequired,
        progress: PropTypes.number,
    }

    _onFileChange = (e) => {
        if (e.target.files.length) {
            const FIVE_MEBIBYTES = 5242880
            const file = e.target.files[0]

            if (file.size > FIVE_MEBIBYTES) {
                this.props.actions.uploadPhotoError({ photo: [ 'The file size must be less than 5MB' ] })
            } else {
                this.props.actions.uploadPhoto(e.target.files[0], this.props.data.uuid)
            }
        }
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        let field_errors = null

        if (errors.photo) {
            field_errors = errors.photo.map(
                (error, index) => <span key={ index }>{ error }<br /></span>
            )

            field_errors = (
                <div className="alert alert--error">
                    { field_errors }
                </div>
            )
        }

        const photoStyle = {
            backgroundImage: 'url(/img/profile-avatar.png)',
        }

        if (this.props.photo && this.props.photo.photo) {
            const photoURL = this.props.photo.photo

            photoStyle.backgroundImage = `url(${ photoURL })`
        }

        let progress = null

        // eslint-disable-next-line no-magic-numbers
        if (this.props.progress && this.props.progress < 100) {
            const style = {
                width: `${ this.props.progress }%`,
            }

            progress = (
                <div className="progress-bar">
                    <div className="progress-bar__meter" style={ style } />
                </div>
            )
        } else {
            progress = <input accept="image/jpeg,image/png" onChange={ this._onFileChange } type="file" />
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-2">
                        <div className="profile-photo" style={ photoStyle } />
                    </div>
                    <div className="grid__span-10">
                        { field_errors }

                        <p>
                            Please upload a headshot photo of yourself in JPEG or PNG.
                            The file size must not exceed 5MB.
                        </p>

                        { progress }
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/personal/photo_form.js